import { render, staticRenderFns } from "./observer.vue?vue&type=template&id=763f2bc0"
import script from "./observer.vue?vue&type=script&lang=js"
export * from "./observer.vue?vue&type=script&lang=js"
import style0 from "./observer.vue?vue&type=style&index=0&id=763f2bc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports